//
//
//
//
//
//
//
//
//
//
//

import { NavBar } from 'vant'

export default {
  name: 'CNavBar',

  components: { NavBar },

  props: {
    title: {
      type: String,
      default: '标题',
    },

    back: { type: Function },
  },

  data () {
    return {}
  },

  computed: {},

  methods: {
    onClickLeft () {
      if (this.back) {
        this.back()
      } else {
        this.$router.go(-1)
      }
    },
  },
}
